module.exports = __webpack_public_path__ + "src/assets/img/share/tips/pleasant/e5807b5c31c3cdfd1ba218d571b76b40.png";